<template>
  <div>
    <div v-if="error">
      <error404 msg="Nenhum Usuario Encontrado" urlBack="/usuarios"></error404>
    </div>
    <div v-else-if="dadosUsuario">
      <div class="text-right mb-3">
        <vs-button color="danger" type="gradient" class="mb-2 text-white forceWhite mr-3" @click="adicionarFreteGratis">
          <vs-icon icon-pack="feather" icon="icon-plus" class="mr-3"></vs-icon>
          Adicionar Frete Grátis
        </vs-button>
      </div>

      <div class="text-right mb-3">
        <vs-button color="primary" type="gradient" class="mb-2 text-white forceWhite mr-3"
          @click="modalCobranca = true">
          <vs-icon icon-pack="feather" icon="icon-dollar-sign" class="mr-3"></vs-icon>
          Adicionar/Remover Saldo
        </vs-button>
      </div>
      <div>
        <vs-popup class="holamundo" :title="'Adicionar/Remover Saldo'" :active.sync="modalCobranca"
          @close="modalCobranca = false">
          <form role="form" @submit.stop.prevent autocomplete="off">
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <span>Valor:</span>
                <money class="w-full vs-inputx vs-input--input large" name="Valor" id="Valor" v-validate="{
                  required: true,
                }" v-model="formAvulso.valor" v-bind="money"></money>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/1 w-full mb-2">
                <vs-textarea label="Observação" v-model="formAvulso.observacao" name="Observação"
                  v-validate="{ required: true }" :state="validateState('Observação')"
                  :danger="validateClass('Observação')" />
              </div>
            </div>
            <vs-alert v-if="$validator.errors.all().length > 0" color="danger" title="Atenção!!" active="true"
              class="my-3" style="height: auto !important">
              <ul>
                <li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">
                  {{ error }}
                </li>
              </ul>
            </vs-alert>
            <vs-button color="success" @click="adicionarAvulso" type="gradient" class="mt-1 mb-2">Adicionar</vs-button>
          </form>
        </vs-popup>
      </div>

      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-w="4" vs-sm="12" vs-xs="12">
          <vs-card>
            <div slot="header">
              <h3>Dados do Associado</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr>
                  <th class="uppercase">Código</th>
                  <td colspan="2">{{ dadosUsuario.idUsuario }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Tipo</th>
                  <td colspan="2">{{ dadosUsuario.nomePerfil }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Nome</th>
                  <td colspan="2">{{ dadosUsuario.nome }}</td>
                </tr>
                <tr>
                  <th class="uppercase">E-mail</th>
                  <td colspan="2">{{ dadosUsuario.email }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Celular</th>
                  <td>
                    {{ dadosUsuario.celular }}
                  </td>
                  <td class="pl-3">
                    <a target="_blank" :href="returnLinkWhats2(
                      dadosUsuario.nome,
                      dadosUsuario.celular
                    )
                      ">
                      <vs-button radius v-tooltip="'Whatsapp'" color="success" type="gradient" icon-pack="fa"
                        icon="fa-whatsapp" class="d-inline"></vs-button>
                    </a>
                  </td>
                </tr>
                <tr v-if="dadosUsuario.cpf">
                  <th class="uppercase">
                    {{ dadosUsuario.tipo == "Pessoa Física" ? "CPF" : "CNPJ" }}
                  </th>
                  <td colspan="2">
                    <p>{{ dadosUsuario.cpf }}</p>
                  </td>
                </tr>
                <tr v-if="dadosUsuario.rg_ie">
                  <th class="uppercase">
                    {{ dadosUsuario.tipo == "Pessoa Física" ? "RG" : "IE" }}
                  </th>
                  <td colspan="2">
                    <p>{{ dadosUsuario.rg_ie }}</p>
                  </td>
                </tr>
                <tr v-if="dadosUsuario.sexo">
                  <th class="uppercase">Sexo</th>
                  <td colspan="2">
                    <p>{{ dadosUsuario.sexo }}</p>
                  </td>
                </tr>
                <tr>
                  <th class="uppercase">Status</th>
                  <td colspan="2">
                    {{ dadosUsuario.deletedAt ? "Inativo" : "Ativo" }}
                  </td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-w="4" vs-sm="12" vs-xs="12">
          <vs-card>
            <div slot="header">
              <h3>Endereço</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr>
                  <th class="uppercase">Cep</th>
                  <td>{{ dadosUsuario.cep }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Endereço</th>
                  <td>{{ dadosUsuario.endereco }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Número</th>
                  <td>{{ dadosUsuario.numero }}</td>
                </tr>
                <tr v-if="dadosUsuario.complemento">
                  <th class="uppercase">Complemento</th>
                  <td>{{ dadosUsuario.complemento }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Bairro</th>
                  <td>{{ dadosUsuario.bairro }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Cidade</th>
                  <td>{{ dadosUsuario.cidade }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Estado</th>
                  <td>{{ dadosUsuario.estado }}</td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-w="4" vs-sm="12" vs-xs="12">
          <vs-card>
            <div slot="header">
              <h3>Dados Complementares</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr v-if="dadosUsuario.dataNascimento">
                  <th class="uppercase">Data de Nascimento</th>
                  <td>
                    {{ dadosUsuario.dataNascimento }}
                  </td>
                </tr>

                <tr v-if="dadosUsuario.fbClientId">
                  <th class="uppercase">FB Client Id</th>
                  <td>
                    {{ dadosUsuario.fbClientId }}
                  </td>
                </tr>
                <tr v-if="dadosUsuario.indicador">
                  <th class="uppercase">indicador</th>
                  <td>{{ dadosUsuario.indicador }}</td>
                </tr>
                <tr v-if="dadosUsuario.saldo">
                  <th class="uppercase">Saldo</th>
                  <td>{{ dadosUsuario.saldo | currency }}</td>
                </tr>
                <tr>
                  <th v-if="dadosUsuario.createdAt" class="uppercase">
                    Data de Cadastro
                  </th>
                  <td>{{ formataData(dadosUsuario.createdAt) }}</td>
                </tr>
                <tr v-if="dadosUsuario.cupomUtilizado">
                  <th class="uppercase">cupom Utilizado</th>
                  <td>{{ dadosUsuario.cupomUtilizado }}</td>
                </tr>
                <tr v-if="
                  dadosUsuario.financeiro &&
                  dadosUsuario.financeiro.length > 0
                ">
                  <th class="uppercase">Total de Pix Pagos</th>
                  <td>{{ buscaPixPagos() | currency }}</td>
                </tr>
                <tr v-if="
                  dadosUsuario.financeiro &&
                  dadosUsuario.financeiro.length > 0
                ">
                  <th class="uppercase">Total de Pix Em aberto</th>
                  <td>{{ buscaPixAbertos() | currency }}</td>
                </tr>
                <tr v-if="
                  dadosUsuario.aberturas && dadosUsuario.aberturas.length > 0
                ">
                  <th class="uppercase">Aberturas</th>
                  <td>
                    {{
                      dadosUsuario.aberturas && dadosUsuario.aberturas.length
                    }}
                  </td>
                </tr>
                <tr v-if="
                  dadosUsuario.aberturas && dadosUsuario.aberturas.length > 0
                ">
                  <th class="uppercase">Valor Total de Caixas Abertas</th>
                  <td>{{ buscaCaixasAbertas() | currency }}</td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col>
          <vs-card>
            <!-- veiculos -->
            <vs-tabs alignment="fixed">
              <vs-tab label="Financeiro" v-if="dadosUsuario.financeiro">
                <div v-if="dadosUsuario.financeiro.length == 0">
                  <vs-alert style="height: auto" active="true" color="danger">
                    Nenhum Registro Financeiro Encontrado
                  </vs-alert>
                </div>

                <div v-else v-for="item in dadosUsuario.financeiro" :key="item.id_boleto">
                  <vs-collapse type="border" v-if="!item.deletedAt">
                    <vs-collapse-item>
                      <div slot="header">
                        {{ formatarDescricaoItem(item) }}

                        <vs-chip v-if="item.nomeStatus" class="mr-4" :color="getStatusBoletoColor(item.nomeStatus)">
                          {{ item.nomeStatus }}
                        </vs-chip>

                        <vs-chip v-if="validaVencido(item)" class="mr-4" color="danger">
                          Vencido
                        </vs-chip>
                      </div>
                      <vs-row>
                        <vs-col vs-type="flex" vs-justify="center" vs-w="12" vs-sm="12" vs-xs="12">
                          <table class="table table-bordered">
                            <tr v-if="item.idRegistroFinanceiro">
                              <th class="uppercase">ID</th>
                              <td>{{ item.idRegistroFinanceiro }}</td>
                            </tr>
                            <tr v-if="item.nossoNumero">
                              <th class="uppercase">Nosso Número</th>
                              <td>{{ item.nossoNumero }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Data de Emissão</th>
                              <td>
                                {{ formataData(item.createdAt) }}
                              </td>
                            </tr>
                            <tr>
                              <th class="uppercase">Data de Vencimento</th>
                              <td>
                                {{ formataData(item.dataVencimento) }}
                              </td>
                            </tr>
                            <tr v-if="item.dataPagamento">
                              <th class="uppercase">Data de Pagamento</th>
                              <td>
                                {{ formataData(item.dataPagamento) }}
                              </td>
                            </tr>
                            <tr v-if="item.dataBaixaManual">
                              <th class="uppercase">Baixa Manual</th>
                              <td>
                                em {{ formataData(item.dataBaixaManual) }}, por
                                {{ item.baixadoPor }}
                              </td>
                            </tr>
                            <tr>
                              <th class="uppercase">Valor</th>
                              <td>
                                <span>{{
                                  item.valor | currency
                                }}</span>
                              </td>
                            </tr>
                            <tr v-if="item.dataPagamento">
                              <th class="uppercase">Valor Pago</th>
                              <td>
                                <span>{{
                                  item.valor | currency
                                }}</span>
                              </td>
                            </tr>
                            <tr v-if="item.linhaDigitavel">
                              <th class="uppercase">Linha Digitavel</th>
                              <td>{{ item.linhaDigitavel }}</td>
                            </tr>
                            <tr v-if="item.linhaDigitavel">
                              <th class="uppercase">Link Boleto</th>
                              <td>
                                <router-link target="_blank"
                                  :to="`/Boleto/${item.idRegistroFinanceiro}?nn=${item.nossoNumero}`">Visualizar
                                  Boleto</router-link>
                              </td>
                            </tr>

                            <tr v-if="item.pixImage">
                              <th class="uppercase">Pix Qr Imagem</th>
                              <td>
                                <VueQr :text="item.pixQrCode" />
                              </td>
                            </tr>
                            <tr v-if="item.pixQrCode">
                              <th class="uppercase">Pix Qr Code</th>
                              <td style="word-break: break-all">
                                {{ item.pixQrCode }}
                              </td>
                            </tr>
                            <tr v-if="
                              item.id_status == 3 &&
                              item.forma_pagamento != 'Cartão de Crédito'
                            ">
                              <th>Enviar Msg</th>
                              <td>
                                <a target="_blank" :href="returnLinkWhats(item)">
                                  <vs-button v-tooltip="'Whatsapp'" radius color="success" type="gradient"
                                    icon-pack="fa" icon="fa-whatsapp" class="d-inline"></vs-button>
                                </a>
                              </td>
                            </tr>
                            <tr v-if="item.observacao">
                              <th class="uppercase">Observação</th>
                              <td style="word-break: break-all">
                                {{ item.observacao }}
                              </td>
                            </tr>
                            <tr v-if="item.motivoCancelamentoExclusao">
                              <th class="uppercase">Motivo Cancelamento</th>
                              <td style="word-break: break-all">
                                {{ item.motivoCancelamentoExclusao }}
                              </td>
                            </tr>
                          </table>
                        </vs-col>
                      </vs-row>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
              </vs-tab>
              <vs-tab label="Aberturas" v-if="dadosUsuario.aberturas">
                <div v-if="dadosUsuario.aberturas.length == 0">
                  <vs-alert style="height: auto" active="true" color="danger">
                    Nenhum Registro de Abertura Encontrado
                  </vs-alert>
                </div>
                <table v-else class="table table-bordered">
                  <tr>
                    <th class="uppercase">Sorteio</th>
                    <th class="uppercase">Item</th>
                    <th class="uppercase">Caixa</th>
                    <th class="uppercase">Odd Sorteada</th>
                    <th class="uppercase">Valor Item</th>
                    <th class="uppercase">Valor Caixa</th>
                    <th class="uppercase">Vendido Por</th>
                  </tr>
                  <tr v-for="item in dadosUsuario.aberturas" :key="item.idSorteio">
                    <td>
                      {{ item.idSorteio }} - {{ formataData(item.createdAt)
                      }}<br />{{ item.nomeItem }} <br />{{ item.chave }}
                    </td>
                    <td><img :src="item.imagem" width="100" /></td>
                    <td>{{ item.nomeCaixa }}</td>
                    <td>{{ item.oddSorteada }}</td>
                    <td>
                      <span>{{
                        item.valor | currency
                      }}</span>
                    </td>
                    <td>R${{ item.valorPago | currency }}</td>
                    <td>
                      <span v-if="item.vendidoPor">R${{
                        item.vendidoPor | currency
                      }}</span><span v-else>Não Vendido</span>
                    </td>
                  </tr>
                </table>
              </vs-tab>
              <vs-tab label="Historico Geral" v-if="dadosUsuario.historicoGeral">
                <div v-if="dadosUsuario.historicoGeral.length == 0">
                  <vs-alert style="height: auto" active="true" color="danger">
                    Nenhum Registro de Historico
                  </vs-alert>
                </div>
                <table v-else class="table table-bordered">
                  <tr>
                    <th class="uppercase">Data</th>
                    <th class="uppercase">Tipo de Transação</th>
                    <th class="uppercase">C/D</th>
                    <th class="uppercase">Detalhe</th>
                    <th class="uppercase">Valor</th>
                  </tr>
                  <tr v-for="item in dadosUsuario.historicoGeral" :key="item.idTransacao" :class="`text-white ${item.tipo == 'Crédito' ? 'bg-success' : 'bg-danger'
                    }`">
                    <td>{{ formataData(item.createdAt) }}</td>
                    <td>{{ item.tipoTransacao }}</td>
                    <td>{{ item.tipo }}</td>
                    <td>
                      <div v-if="item.idSorteio">
                        Sorteio: {{ item.idSorteio }}
                      </div>
                      <div v-if="item.chave">chave: {{ item.chave }}</div>
                      <div v-if="item.idTransacao">
                        idTransacao: {{ item.idTransacao }}
                      </div>
                      <div v-if="item.nomeCaixa">
                        Caixa: {{ item.nomeCaixa }}
                      </div>
                      <div v-if="item.nomeItem">Item: {{ item.nomeItem }}</div>
                      <div v-if="item.formaPagamento">
                        Forma de Pagamento: {{ item.formaPagamento }}
                      </div>
                      <div v-if="item.observacao">
                        Observação: {{ item.observacao }}
                      </div>
                    </td>
                    <td>
                      <span>R${{
                        item.valor | currency
                      }}</span>
                    </td>
                  </tr>
                </table>
              </vs-tab>
              <vs-tab label="Encomendas" v-if="dadosUsuario.encomendas">
                <div v-if="dadosUsuario.encomendas.length == 0">
                  <vs-alert style="height: auto" active="true" color="danger">
                    Nenhum Registro de Encomendas Encontrado
                  </vs-alert>
                </div>
                <table v-else class="table table-bordered">
                  <tr>
                    <th class="uppercase">Id</th>
                    <th class="uppercase">Data de Abertura</th>
                    <th class="uppercase">Valor do Frete</th>
                    <th class="uppercase">Status</th>
                    <th class="uppercase">Ação</th>
                  </tr>
                  <tr v-for="item in dadosUsuario.encomendas" :key="item.idSorteio">
                    <td>{{ item.idEncomenda }} <br />{{ item.chave }}</td>
                    <td>{{ formataData(item.createdAt) }}</td>
                    <td>{{ item.valorFrete | currency }}</td>
                    <td>{{ item.nomeStatus }}</td>
                    <td>
                      <a target="_blank" :href="`/detalheEncomenda/${item.idEncomenda}`">
                        <vs-button v-tooltip="'Detalhes do Encomenda'" radius color="success" type="gradient"
                          icon-pack="feather" icon="icon-search" class="d-inline"></vs-button>
                      </a>
                      <vs-button v-if="item.idStatus != 4" v-tooltip="'Cancelar Encomenda'" radius color="danger"
                        type="gradient" icon-pack="feather" icon="icon-trash" class="d-inline"
                        @click="abreModalEncomenda(item.idEncomenda)"></vs-button>
                    </td>
                  </tr>
                </table>
              </vs-tab>
              <vs-tab label="Frete Gratis" v-if="dadosUsuario.freteGratis">
                <div v-if="dadosUsuario.freteGratis.length == 0">
                  <vs-alert style="height: auto" active="true" color="danger">
                    Nenhum Registro de Frete Gratis Encontrado
                  </vs-alert>
                </div>
                <table v-else class="table table-bordered">
                  <tr>
                    <th class="uppercase">Id</th>
                    <th class="uppercase">Data de Criação</th>
                    <th class="uppercase">Data de Utilização</th>
                    <th class="uppercase">Ação</th>
                  </tr>
                  <tr v-for="item in dadosUsuario.freteGratis" :key="item.idUsuarioFrete">
                    <td>
                      {{ item.idUsuarioFrete }} <br />{{ item.chaveFrete }}
                    </td>
                    <td>{{ formataData(item.createdAt) }}</td>
                    <td>
                      <span v-if="item.dataUtilizacao">{{
                        formataData(item.dataUtilizacao)
                      }}</span><span v-else>Não Utilizado</span>
                    </td>
                    <td>
                      <a v-if="item.dataUtilizacao" target="_blank" :href="`/detalheEncomenda/${item.idEncomenda}`">
                        <vs-button v-tooltip="'Detalhes do Encomenda'" radius color="success" type="gradient"
                          icon-pack="feather" icon="icon-search" class="d-inline"></vs-button>
                      </a>
                    </td>
                  </tr>
                </table>
              </vs-tab>
            </vs-tabs>
          </vs-card>
        </vs-col>
      </vs-row>
      <vs-popup class="holamundo" :title="'Cancelar Encomenda'" :active.sync="modalEncomenda"
        @close="modalEncomenda = false">
        <vs-alert color="danger" title="Atenção!!" active="true" class="my-3" style="height: auto !important">Você tem
          certeza que deseja Cancelar Encomeda? Todos os itens serão
          liberados para venda ou para outra encomenda
        </vs-alert>
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button color="danger" type="gradient" icon-pack="feather" icon="icon-trash-2" class="d-inline"
              @click="cancelarEncomenda()">Sim, Cancelar</vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import service from "./../../../services";
import locale from "./../../../locale";
import Datepicker from "vuejs-datepicker";
import { Money } from "v-money";
import moment from "moment";
import BotaoSubmit from "./../../../components/BotaoSubmit";
import jwt from "jsonwebtoken";
import error404 from "./../../pages/Error404.vue";
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import vSelect from "vue-select";
import VueQr from "vue-qr";
export default {
  components: {
    Datepicker,
    Money,
    BotaoSubmit,
    swiper,
    swiperSlide,
    "v-select": vSelect,
    VueQr,
    error404,
  },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$",
        suffix: "",
        precision: 2,
      },
      error: false,
      aguardeCadastro: false,
      dadosUsuario: null,
      modalCobranca: false,
      modalEncomenda: false,
      idEncomenda: null,
      formAvulso: {
        idUsuario: this.$route.params.idUsuario,
        valor: 0,
        observacao: null,
        tipo: "Crédito",
      },
    };
  },
  methods: {
    abreModalEncomenda(idEncomenda) {
      this.modalEncomenda = true;
      this.idEncomenda = idEncomenda;
    },
    returnLinkWhats2(nome) {
      let texto = `Olá ${nome}, tudo bem? 😉 \nSomos do *Box da Sorte*,`;
      let textoEncode = encodeURI(texto);

      let link = "";
      link = `https://api.whatsapp.com/send?phone=5511934471420&text=${textoEncode}`;

      return link;
    },
    formatarDescricaoItem(item) {
      let str =
        "Solicitação de Crédito Saldo em " +
        this.formataData(item.createdAt) +
        " no valor de R$ " +
        item.valor.toFixed(2);

      return str;
    },

    getStatusBoletoColor(data) {
      const warning = ["ABERTO", "BAIXADO COM PENDÊNCIA", "Em Aberto"];

      const success = ["BAIXADO", "Finalizado"];

      const danger = [
        undefined,
        "",
        "CANCELADO",
        "Cancelado",
        "Processado com Falha",
      ];

      const dark = ["EXCLUIDO", "Não Processado"];

      const primary = ["Em Processamento"];

      if (warning.includes(data)) return "warning";
      if (success.includes(data)) return "success";
      if (danger.includes(data)) return "danger";
      if (dark.includes(data)) return "dark";
      if (primary.includes(data)) return "primary";
    },
    validaVencido(item) {
      if (
        item.nomeStatus != "Finalizado" &&
        item.nomeStatus != "Cancelado" &&
        item.nomeStatus != "BAIXADO"
      ) {
        if (moment().diff(moment(item.dataVencimento), "days") > 0) return true;
      }
      return false;
    },
    buscaPixPagos() {
      let valor = 0;
      this.dadosUsuario.financeiro.forEach((element) => {
        if (element.dataPagamento) valor = valor + element.valor;
      });
      return valor;
    },
    buscaPixAbertos() {
      let valor = 0;
      this.dadosUsuario.financeiro.forEach((element) => {
        if (!element.dataPagamento) valor = valor + element.valor;
      });
      return valor;
    },
    buscaCaixasAbertas() {
      let valor = 0;
      this.dadosUsuario.aberturas.forEach((element) => {
        valor = valor + element.valorPago;
      });
      return valor;
    },
    adicionarFreteGratis() {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Confirmação",
        text: "Você tem certeza que deseja adicionar frete grátis?",
        acceptText: "Adicionar",
        cancelText: "Cancelar",
        accept: () => {
          this.$vs.loading();
          service
            .post("Usuario", "AdicionarFreteGratis", {
              idUsuario: this.dadosUsuario.idUsuario,
            })
            .then(() => {
              this.$vs.notify({
                position: "top-center",
                title: "Obrigado",
                text: "Operação realizada com sucesso",
                color: "success",
              });
              this.buscaDados();
            })
            .catch((error) => {
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        },
      });
    },

    cancelarEncomenda() {
      this.$vs.loading();
      service
        .post("Usuario", "CancelarEncomenda", { idEncomenda: this.idEncomenda })
        .then((res) => {
          this.aguardeCadastro = false;
          this.modalEncomenda = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-center",
            title: "Obrigado",
            text: `Operação Realizada com sucesso`,
            color: "success",
          });

          this.buscaDados();
        })
        .catch((error) => {
          this.aguardeCadastro = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
        });
    },
    adicionarAvulso() {
      console.log("batue aqui");
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          service
            .post("Usuario", "AdicionarSaldoADM", this.formAvulso)
            .then((res) => {
              this.aguardeCadastro = false;
              this.modalCobranca = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: "top-center",
                title: "Obrigado",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });

              this.buscaDados();
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },
    buscaDados() {
      this.$vs.loading();
      var objSend = {};
      objSend.idUsuario = this.$route.params.idUsuario;
      service
        .post("Usuario", "DetalheUsuario", objSend)
        .then((res) => {
          console.log(res.data);

          this.dadosUsuario = res.data;

          if (this.dadosUsuario.aberturas)
            this.dadosUsuario.aberturas = JSON.parse(
              this.dadosUsuario.aberturas
            );
          if (this.dadosUsuario.encomendas)
            this.dadosUsuario.encomendas = JSON.parse(
              this.dadosUsuario.encomendas
            );

          if (this.dadosUsuario.financeiro)
            this.dadosUsuario.financeiro = JSON.parse(
              this.dadosUsuario.financeiro
            );

          if (this.dadosUsuario.historicoGeral)
            this.dadosUsuario.historicoGeral = JSON.parse(
              this.dadosUsuario.historicoGeral
            );

          if (this.dadosUsuario.freteGratis)
            this.dadosUsuario.freteGratis = JSON.parse(
              this.dadosUsuario.freteGratis
            );

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.error = true;
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    formataData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm:ss");
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            value: element[campoPK],
            text: element[campoDescricao],
          });
        });
      });
    },
  },
  mounted() {
    this.$validator.localize("ptBr", locale);
    this.buscaDados();
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}
</style>

<style scoped lang="scss">
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 2px;
    padding-left: 10px;
  }

  tr:nth-child(2n) {
    background: #efefef;
  }
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.forceWhite:hover {
  color: #fff !important;
}

.truncText {
  max-width: 70ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style>
.vs-popup {
  width: 1024px !important;
  max-width: 95% !important;
}

.vs-alert {
  cursor: pointer;
}

.main-popup-anexo.con-vs-popup .vs-popup {
  width: 40% !important;
}
</style>
